import { useState, useEffect } from 'react';
import { tilesAPI } from '../utils/apiClient';

export const useTiles = () => {
  const [tiles, setTiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTiles = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await tilesAPI.getAllTiles();
      setTiles(response.tiles || response);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTiles();
  }, []);

  const refetch = () => {
    fetchTiles();
  };

  return {
    tiles,
    loading,
    error,
    refetch
  };
};